<div class="overview" *ngIf="showOverview">
	<div
		class="overview__header"
		[ngClass]="{
			'zk-flex-col md:zk-flex-row zk-gap-3': data.notifications.length > 0
		}"
	>
		<div>
			<div class="overview__headline">
				<span class="zk-capitalize">
					{{ firstName }}
				</span>
				<span>{{ 'JOURNEY.ON_A_JOURNEY' | translate }}:</span>
			</div>
			<div class="overview__title">{{ data.title }}</div>
		</div>
		<div class="zk-flex zk-gap-5 zk-items-center">
			<div
				class="overview__notifications"
				*ngIf="data.notifications.length > 0"
			>
				<div
					class="zk-flex zk-gap-3 zk-items-center"
					*ngFor="let notifification of data.notifications"
				>
					<span
						(click)="
							goTo.emit({ tab: notifification.type, item: notifification.id })
						"
						>{{ notifification.text }}</span
					>
					<span class="freud-icon freud-icon-list-check freud-icon-md"></span>
				</div>
			</div>
			<circular-progress
				[progress]="data.board.percentage"
				[color]="getColor(data.board.percentage)"
				size="medium"
			>
				<span class="overview__percentage">{{ data.board.percentage }}%</span>
			</circular-progress>
		</div>
	</div>
	<div class="overview__body" *ngIf="isExpanded">
		<journey-board
			(goTo)="goTo.emit($event)"
			[therapy]="data.board.sessions.board.therapy"
			[psychiatry]="data.board.sessions.board.psychiatry"
			[contents]="data.board.contents.board"
			[evaluations]="data.board.evaluations.board"
		></journey-board>
	</div>
	<div class="overview__footer">
		<div
			(click)="isExpanded = !isExpanded"
			class="overview__expandable"
			[ngClass]="{
				'overview__expandable--expanded': isExpanded,
				'overview__expandable--contracted': !isExpanded
			}"
		>
			<div>
				<div *ngIf="isExpanded">
					<span class="freud-icon freud-icon-chevron-up freud-icon-md"></span>
				</div>
				<div *ngIf="!isExpanded" class="zk-flex zk-items-center">
					<span>Progresso</span>
					<span class="freud-icon freud-icon-chevron-down freud-icon-md"></span>
				</div>
			</div>
		</div>
	</div>
</div>
